'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Grouping(id, created, account, kind, name, description) {
  this.n6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.Lv = null;
  this.Ev = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.u5 = null;
  this.qn = null;
  this.u4 = null;
  this.n6 = id;
  this.Lv = created;
  this.Ev = account;
  this.u5 = kind;
  this.qn = name;
  this.u4 = description;
}
export { $c_Lpresto_types$Grouping as $c_Lpresto_types$Grouping };
$p = $c_Lpresto_types$Grouping.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Grouping;
/** @constructor */
function $h_Lpresto_types$Grouping() {
}
export { $h_Lpresto_types$Grouping as $h_Lpresto_types$Grouping };
$h_Lpresto_types$Grouping.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Grouping"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.n6;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Lv));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.Ev;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.qn));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.u4));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 6);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Grouping)) {
    var this$1 = this.n6;
    var b = x$0.n6;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var x = this.Lv;
      var x$2 = x$0.Lv;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var this$2 = this.Ev;
      var b$1 = x$0.Ev;
      var $x_2 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.u5;
      var x$4 = x$0.u5;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.qn === x$0.qn))) {
      return (this.u4 === x$0.u4);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "Grouping";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.n6;
      break;
    }
    case 1: {
      return this.Lv;
      break;
    }
    case 2: {
      return this.Ev;
      break;
    }
    case 3: {
      return this.u5;
      break;
    }
    case 4: {
      return this.qn;
      break;
    }
    case 5: {
      return this.u4;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.k4 = (function() {
  return this.n6;
});
function $isArrayOf_Lpresto_types$Grouping(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jX)));
}
export { $isArrayOf_Lpresto_types$Grouping as $isArrayOf_Lpresto_types$Grouping };
var $d_Lpresto_types$Grouping = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Grouping, "presto.types$Grouping", ({
  jX: 1,
  aH: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Grouping as $d_Lpresto_types$Grouping };
//# sourceMappingURL=presto.types$-Grouping.js.map
